export default __webpack_public_path__ + "static/media/usdt_eth.0a5ff949.svg";